export default __webpack_public_path__ + "static/media/exploradogs-logo.9a7f4a05.png";